import { combineReducers } from 'redux';
import featured from './offers.featured';
import models from './offers.models';
import upcoming from './offers.upcoming';
export default combineReducers({ models, featured, upcoming });
